/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { transactionsSearch } from "../../funcs/transactionsSearch.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  customerId: z.string().optional(),
  orderId: z.string().optional(),
  productId: z.string().optional(),
  pageNumber: z.number().default(1),
  pageSize: z.number().default(10),
};

export const tool$transactionsSearch: ToolDefinition<typeof args> = {
  name: "transactions-search",
  description: `List all transactions

Search and retrieve payment transactions. Filter by customer, product, date range, and status.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await transactionsSearch(
      client,
      args.customerId,
      args.orderId,
      args.productId,
      args.pageNumber,
      args.pageSize,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
